import React from "react";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import {
  hasMarketIntelligencePlan,
  welcomeMetricRequiresMarketIntelligencePlan,
} from "util/marketIntelligenceAccess";
import styles from "./WelcomeMarketIntelligencePlanGate.module.scss";

/**
 * Greys out Digital Experience Score (metric 18) when the org lacks
 * Market Intelligence or Full Intelligence.
 */
export function WelcomeMarketIntelligencePlanGate({
  metricId,
  subscriptionRow,
  children,
  className,
}) {
  const { t } = useTranslation();
  const needsPlan = welcomeMetricRequiresMarketIntelligencePlan(metricId);
  const enabled = !needsPlan || hasMarketIntelligencePlan(subscriptionRow);

  if (enabled) {
    return children;
  }

  return (
    <Tooltip
      title={t("welcome.desPlanRequiredTooltip")}
      placement="top"
      overlayClassName={styles.tooltipOverlay}
    >
      <div
        className={`${styles.gateWrap} ${className || ""}`.trim()}
        aria-disabled="true"
      >
        <div className={styles.gateContent}>{children}</div>
        <div className={styles.gateVeil} aria-hidden="true" />
      </div>
    </Tooltip>
  );
}

export default WelcomeMarketIntelligencePlanGate;
